import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import { TokenStorage } from '../storages/token.storage';
import { Router } from '@angular/router';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public token: TokenStorage, public router: Router) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const at = this.token.getToken();

    if (at != null) {
      const requestClone = request.clone({
        setHeaders: {
          'Authorization': `Bearer ${at.access_token}`,
          'Access-Control-Allow-Origin': '*'
        }
      });

      return next.handle(requestClone).do((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401 || err.status === 400) {
            this.router.navigate(['login']);
          }
        }
      });
    } else {
      return next.handle(request).do((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401 || err.status === 400) {
            this.router.navigate(['login']);
          }
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/interceptors/token-interceptor.ts